import { Map } from 'immutable';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import ATTRIBUTE from '../../../../constants/attributes';

export function collections({ channel, preview }) {
  return { payload: Map({ type: OPERATIONS[channel].COLLECTIONS, value: preview.get(ATTRIBUTE.COLLECTIONS) }) };
}
